<template>
  <div id="bi">
    <div ref="container" id="container" class="container"></div>
    <!--<div class="mask"></div>-->
    <Nav></Nav>
    <div class="data_left" :class="panelLeftStyle">
      <DataItem itemTitle="系统数据情况" itemType="rightTop"></DataItem>
      <DataItem itemTitle="装备状态" itemType="rightCenter"></DataItem>
      <DataItem itemTitle="任务派发列表" itemType="rightBottom"></DataItem>
      <div class="panelSwitch panelSwitch_left" @click="changeStatus('left', panelLeftStatus)">
        <i class="el-icon-arrow-left arrow_icon"></i>
      </div>
      <MarkerSearchBox v-if="MarkerSearchBoxStatus" class="markerSearchBox" @showCarMarker="showCarMarker" @hideCarMarker="closeCarMarker"></MarkerSearchBox>
      <Trajectory v-if="trajectoryStatus" class="trajectory" @showBaseLayer="showBaseLayer"></Trajectory>
    </div>
    <div class="data_right" :class="panelRightStyle">
      <div class="panelSwitch panelSwitch_right" @click="changeStatus('right', panelRightStatus)">
        <i class="el-icon-arrow-right arrow_icon"></i>
      </div>
      <DataItem ref="itemLeftTop" itemTitle="每日申请单量趋势" itemType="leftTop"></DataItem>
      <DataItem itemTitle="每日任务数量趋势" itemType="leftCenter"></DataItem>
      <DataItem itemTitle="资产申请列表" itemType="leftBottom"></DataItem>
    </div>
  </div>
</template>

<script>
import { getMap, initMap } from '@/utils/mainMap2.js';
import { fetchMockData } from '@/utils/mock.js';
import { deepClone, formatTimestamp } from '@/utils';
import Nav from '@/components/map/nav.vue';
import MarkerSearchBox from '@/components/map/MarkerSearchBox';
import Trajectory from '@/components/map/Trajectory';
import DataItem from '@/components/map/DataItem';
import personIcon from '@/assets/icon/rescue_personnel.png';
import carIcon from '@/assets/icon/rescue_vehicle.png';
import stashIcon from '@/assets/icon/stash.png';
import centerIcon from '@/assets/icon/five_star.png';
import carMarkerIcon from '@/assets/icon/car_icon.gif';
import { mapActions, mapState } from 'vuex';

// 高德可视化类
let loca;
// 地图初始化相关参数
const SETTING = {
  center: [111.165109, 34.228638]
};
// 地图数据提示浮窗
let normalMarker;

// 地图marker内容
function getMarkerStr(markerOption) {
  let markerStr = '';
  switch (markerOption.type) {
    case 'person':
      markerStr = `<p>救援队名称：${markerOption.name}</p><p>救援队地址：${markerOption.address}</p><p>救援队人数：${markerOption.memberNum}</p><p>救援队电话：${markerOption.phone}</p><p style="padding-top: 10px;">任务范围：</p><p>${markerOption.master_field}</p>`;
      break;
    case 'car':
      markerStr = `<p>车辆编号：${markerOption.name}</p><p>车辆地址：${markerOption.address}</p><p>车辆所属部门：${markerOption.dept}</p><p style="padding-top: 10px;">车辆详情：</p><p>${markerOption.contact}</p>`;
      break;
    case 'center':
      markerStr = `<p>应急中心名称：${markerOption.name}</p><p>应急中心地址：${markerOption.address}</p><p style="padding-top: 10px;">应急中心详情：</p><p>${markerOption.contact}</p>`;
      break;
    case 'stash':
      markerStr = `<p>仓库名称：${markerOption.name}</p><p>仓库地址：${markerOption.address}</p><p>装备总数：${markerOption.total_cnt}</p><p>装备使用中总数：${markerOption.out_cnt}</p><p style="padding-top: 10px;">仓库详情：</p><p>${markerOption.contact}</p>`;
      break;
    default:
      markerStr = `<p>名称：${markerOption.name}</p><p>地址：${markerOption.address}</p>`;
  }
  return markerStr;
}

// 初始化地图
async function init() {
  const map = await initMap({
    viewMode: '3D',
    showBuildingBlock: false,
    center: SETTING.center,
    zoom: 9.45,
    pitch: 42.0,
    rotation: 4.9,
    // mapStyle: 'amap://styles/light',
    mapStyle: 'amap://styles/blue',
    skyColor: '#c8edff'
  });
  map.on('zoomend', (e) => {
    console.log(map.getZoom());
  });
  map.on('click', (e) => {
    const { lng, lat } = e.lnglat;
    console.log([lng, lat]);
    if (normalMarker) {
      map.remove(normalMarker);
    }
  });

  loca = new Loca.Container({
    map
  });

  normalMarker = new AMap.Marker({
    zooms: [2, 20]
  });
}
// 初始化图层
async function initLayers(mapOption) {
  await initCoverPOILayer(mapOption);
  await initPolygonLayer();
}
// 初始化Point图层
async function initCoverPOILayer(mapOption) {
  const labelsLayer = (window.labelsLayer = new Loca.LabelsLayer({
    zIndex: 100,
    opacity: 1,
    visible: true,
    depth: true,
    zooms: [1, 20]
  }));
  const geo = new Loca.GeoJSONSource({ data: mapOption });
  loca.add(labelsLayer);
  labelsLayer.on('complete', () => {
    const labelMarkers = labelsLayer.getLabelsLayer().getAllOverlays();
    for (const marker of labelMarkers) {
      marker.on('mouseover', (e) => {
        const position = e.data.data && e.data.data.position;
        const markerStr = getMarkerStr(marker.getExtData());
        if (position) {
          normalMarker.setContent(`<div style="
                color: white;font-family: 'YouSheBiaoTiHei';
                background: rgb(207,227,231);
                background: linear-gradient(97deg, rgba(1, 195, 147,0.6166667350533963) 0%, rgba(1, 195, 147,.8) 100%);
                line-height: 20px;width: 310px;border-radius: 3px;padding: 6px 10px;text-align: left;
                box-shadow: 0 2px 6px 0 rgba(1, 195, 147, 0.5);position: relative;top: 40px;left:200px;font-size: 18px;">${markerStr}</div>`);
          normalMarker.setOffset(new AMap.Pixel(-25, -50));
          normalMarker.setPosition(position);
          getMap().add(normalMarker);
        }
      });
      marker.on('mouseout', () => {
        getMap().remove(normalMarker);
      });
    }
  });
  labelsLayer.setSource(geo);
  // labelsLayer.setStyle的配置项即AMap.LabelMarker的配置项
  labelsLayer.setStyle({
    icon: {
      type: 'image',
      image: (index, feat) => {
        if (feat.properties.type === 'person') {
          return personIcon;
        } else if (feat.properties.type === 'car') {
          return carIcon;
        } else if (feat.properties.type === 'center') {
          return centerIcon;
        } else {
          return stashIcon;
        }
      },
      size: [50, 50],
      anchor: 'top-left'
    },
    text: {
      // 每项配置都可使用回调函数来动态配置
      content: (index, feat) => {
        if (feat.properties.type === 'person') {
          return feat.properties.name;
        } else {
          return feat.properties.name;
        }
      },
      style: {
        fontSize: 12,
        fontWeight: 'normal',
        fillColor: '#5CDE8E',
        strokeColor: '#000',
        strokeWidth: 2
      },
      direction: 'bottom'
    },
    extData: (index, feat) => {
      return feat.properties;
    }
  });
}
// 初始化PolygonLayer图层
async function initPolygonLayer() {
  // 社区边栏
  const polygonLayer = (window.polygonLayer = new Loca.PolygonLayer({
    zIndex: 120,
    cullface: 'none',
    shininess: 1,
    hasBottom: false,
    blockHide: false,
    hasSide: true,
    hasTop: false,
    depth: false
  }));
  const data = await fetchMockData('411200.json');
  const geo = new Loca.GeoJSONSource({ data });
  polygonLayer.setSource(geo);
  polygonLayer.setStyle({
    topColor: function (index, feature) {
      return 'rgba(255,255,255,0)';
    },
    sideTopColor: function (index, feature) {
      // return 'rgba(0,255,255,0)';
      return 'rgba(1, 195, 147, 0)';
    },
    height: 1000,
    altitude: 0
  });
  loca.add(polygonLayer);
}

export default {
  name: 'BiView',
  components: { Nav, DataItem, MarkerSearchBox, Trajectory },
  data() {
    return {
      panelLeftStatus: true,
      panelRightStatus: true,
      trajectoryStatus: false,
      MarkerSearchBoxStatus: true
    };
  },
  computed: {
    ...mapState('bi', ['stashInfo', 'teamInfo', 'baseConfig']),
    createMapOption() {
      const _stashInfo = this.stashInfo;
      const _steamInfo = this.teamInfo;

      const mapData = {
        features: [
          {
            geometry: {
              coordinates: [111.204551, 34.764061],
              type: 'Point'
            },
            type: 'Feature',
            properties: {
              name: '三门峡应急局',
              address: '三门峡应急局',
              contact: '三门峡应急局',
              type: 'center'
            }
          }
        ],
        type: 'FeatureCollection'
      };

      let itemData = [];
      let itemOjb = {};

      if (_stashInfo) {
        _stashInfo.forEach((stashItem) => {
          itemOjb.geometry = {
            coordinates: [stashItem.coordinates.lon, stashItem.coordinates.lat],
            type: 'Point'
          };
          itemOjb.type = 'Feature';
          itemOjb.properties = {
            address: stashItem.address || '',
            contact: stashItem.contact || '',
            out_cnt: stashItem.indicators.out_cnt || 0,
            total_cnt: stashItem.indicators.total_cnt || 0,
            name: stashItem.name || '',
            id: stashItem.id,
            type: 'stash'
          };
          itemData.push(itemOjb);
          itemOjb = {};
        });
        itemData.forEach((item) => {
          mapData.features.push(item);
        });
        itemData = [];
        itemOjb = {};
      }
      if (_steamInfo) {
        _steamInfo.forEach((item) => {
          itemOjb.geometry = {
            coordinates: [item.coordinates.lon, item.coordinates.lat],
            type: 'Point'
          };
          itemOjb.type = 'Feature';
          itemOjb.properties = {
            address: item.address || '',
            master_field: item.master_field || '',
            name: item.name || '',
            id: item.id || '',
            phone: item.phone || '',
            memberNum: item.member.length,
            type: 'person'
          };
          itemData.push(itemOjb);
          itemOjb = {};
        });
        itemData.forEach((item) => {
          mapData.features.push(item);
        });
        itemData = [];
        itemOjb = {};
      }

      return mapData;
    },
    panelLeftStyle() {
      return {
        showPanelLeft: this.panelLeftStatus,
        hidePanelLeft: !this.panelLeftStatus
      };
    },
    panelRightStyle() {
      return {
        showPanelRight: this.panelRightStatus,
        hidePanelRight: !this.panelRightStatus
      };
    }
  },
  created() {},
  async mounted() {
    await this.initializePageData();
    // 初始化地图
    await this.readyMap(this.createMapOption);
    // 创建car标点图层组
    this.overlayGroup = new AMap.OverlayGroup();
    // 创建carMarker信息窗体
    this.infoWindow = new AMap.InfoWindow({
      zooms: [2, 20],
      isCustom: false,
      autoMove: true,
      closeWhenClickMap: false,
      offset: new AMap.Pixel(37, -10),
      anchor: 'bottom-center'
    });
    // carMarker标点集合
    this.carMarkerList = [];
    // 信息窗体轨迹btn click事件挂载全局
    window.getTrajectory = this.getTrajectory;
  },
  methods: {
    ...mapActions('bi', ['getStashInfoFn', 'getTeamInfoFn', 'getApplyOrderInfoFn', 'getQuestInfo', 'getZCInfo', 'getIndicators', 'getConfig', 'getApplyList', 'getTaskList', 'getDeviceLocation']),
    async readyMap(mapOption) {
      try {
        await init();
        await initLayers(mapOption);
      } catch (error) {
        console.error('Error during readyMap:', error);
      }
    },
    // 数据初始化
    async initializePageData() {
      await this.getStashInfoFn();
      await this.getTeamInfoFn();
      await this.getApplyOrderInfoFn();
      await this.getQuestInfo();
      await this.getZCInfo();
      await this.getIndicators();
      await this.getConfig();
      await this.getApplyList();
      await this.getTaskList();
    },
    changeStatus(which, status) {
      if (which === 'left') {
        this.panelLeftStatus = !this.panelLeftStatus;
      } else {
        this.panelRightStatus = !this.panelRightStatus;
      }
    },
    // 显示汽车标点图层
    async showCarMarker() {
      const map = getMap();
      window.labelsLayer.hide(); // 隐藏仓库和队员marker
      this.addBatchMarkers(deepClone(this.$store.state.bi.deviceLocations)); // 批量添加marker
      map.add(this.overlayGroup); // 将标点图层组添加到地图
    },
    // 批量添加marker
    addBatchMarkers(markerData) {
      if (markerData.length > 1) {
        markerData.forEach((data) => {
          const marker = new AMap.Marker({
            position: [data.x, data.y],
            icon: new AMap.Icon({
              size: new AMap.Size(50, 50),
              image: carMarkerIcon,
              imageSize: new AMap.Size(25, 25)
            }),
            title: data.deviceNo
          });
          marker.on('click', () => {
            this.showMarkerInfo(data, marker.getPosition());
          });
          // 将标点添加到标点集合和图层组
          this.carMarkerList.push(marker);
          this.overlayGroup.addOverlay(marker);
        });
      } else {
        const marker = new AMap.Marker({
          position: [markerData[0].x, markerData[0].y],
          icon: new AMap.Icon({
            size: new AMap.Size(50, 50),
            image: carMarkerIcon,
            imageSize: new AMap.Size(25, 25)
          }),
          title: markerData[0].deviceNo
        });
        marker.on('click', () => {
          this.showMarkerInfo(markerData[0], marker.getPosition());
        });
        // 将标点添加到标点集合和图层组
        this.carMarkerList.push(marker);
        this.overlayGroup.addOverlay(marker);
      }
    },
    // 显示救援车辆标点信息
    showMarkerInfo(content, position) {
      const _content = content;
      _content.gpsTime = formatTimestamp(_content.gpsTime);
      _content.recordTime = formatTimestamp(_content.recordTime);
      const map = getMap();
      const afterStyle = `width:${_content.electricity}%;background: rgb(10, 185, 39);height:8px;`;
      const infoWindowStr = `<div style="width: 300px;height: 200px;background-color: white;font-size:15px;font-family: 'NotoSansCJK-Regular';">
                                <p style="font-size: 18px;padding: 5px 0;"><b>${_content.carNo}</b></p>
                                <div style="padding-bottom: 5px;">
                                  <div style="width: 100%;padding-bottom: 5px;display: flex;flex-direction: row;justify-content: flex-start;justify-items: center;align-items: center;">
                                    <div style="width: 50%;"><span style="color: darkgray;padding-right: 15px;">当前速度</span><span>${_content.speed} km/h</span></div>
                                    <div style="width: 50%;"><span style="color: darkgray;padding-right: 15px;">里程数</span><span>${_content.mileage} km</span></div>
                                  </div>
                                  <div style="width: 100%;display: flex;flex-direction: row;justify-content: flex-start;justify-items: center;align-items: center;">
                                    <div style="width: 50%;"><span style="color: darkgray;padding-right: 15px;">当前油量</span><span>${_content.oilLiters} L</span></div>
                                    <div style="width: 50%;"><span style="color: darkgray;padding-right: 15px;">发动机</span><span>${_content.accStatus ? '运行' : '熄火'}</span></div>
                                  </div>
                                </div>
                                <div style="padding-bottom: 5px;">
                                  <div style="width: 100%;"><span style="color: darkgray;padding-right: 15px;">北斗时间</span><span>${_content.gpsTime}</span></div>
                                </div>
                                <div style="padding-bottom: 5px;">
                                  <div style="width: 100%;"><span style="color: darkgray;padding-right: 15px;">信号时间</span><span>${_content.recordTime}</span></div>
                                </div>
                                <div style="padding-bottom: 18px;">
                                  <div style="width: 100%;display: flex;flex-direction: row;justify-content: flex-start;justify-items: center;align-items: center;">
                                    <span style="color: darkgray;padding-right: 15px;">设备电量</span>
                                    <div id="elect" style="width: 20px;height: 10px;border: 1px solid #999;position: relative;display: inline-block;margin-right: 4px;">
                                      <style>
                                          #elect::after {
                                            content: '';
                                            width: 2px;
                                            height: 4px;
                                            background: #999;
                                            position: absolute;
                                            right: -3px;
                                            top: 2px;
                                          }
                                      </style>
                                      <div id="enow" style="${afterStyle}"></div>
                                    </div>
                                    <span style="padding-left: 2px;">${_content.electricity}%</span>
                                  </div>
                                </div>
                                <div style="padding-bottom: 5px;">
                                    <button id="getTrajectory" onclick="window.getTrajectory()" style="font-size: 12px;padding: 3px 8px;border: 1px solid darkgray;border-radius: 2px;color: #333333;">轨迹</button>
                                    <style>
                                        #getTrajectory:hover {
                                            color: lightblue;
                                            border: 1px solid lightblue;
                                            cursor: pointer;
                                        }
                                    </style>
                                </div>
                            </div>`;
      if (this.infoWindow && map) {
        this.infoWindow.setContent(infoWindowStr);
        this.infoWindow.open(map, position);
      } else {
        console.error('InfoWindow or map is not initialized');
      }
    },
    // 隐藏汽车标点图层
    closeCarMarker() {
      // this.overlayGroup.hide();
      window.mainMap.remove(this.overlayGroup);
    },
    // 返回初始布局
    showBaseLayer() {
      this.trajectoryStatus = false;
      this.MarkerSearchBoxStatus = true;
      this.panelLeftStatus = true;
      this.panelRightStatus = true;
      window.labelsLayer.show();
      window.polygonLayer.show();
      // window.mainMap.setFitView();
      window.mainMap.setCenter([111.099259, 34.123574]);
      window.mainMap.setZoom(9.6);
    },
    // 查看汽车轨迹
    getTrajectory() {
      this.trajectoryStatus = true;
      this.MarkerSearchBoxStatus = false;
      this.panelLeftStatus = false;
      this.panelRightStatus = false;
      window.labelsLayer.hide();
      window.mainMap.remove(this.overlayGroup);
      window.polygonLayer.hide();
      this.infoWindow.close();
    }
  },
  beforeDestroy() {}
};
</script>

<style lang="scss" scoped>
@import '../assets/css/BiView/biView.scss';
.markerSearchBox {
  width: auto;
  position: absolute;
  bottom: 10px;
  left: 105%;
}
.trajectory {
  width: auto;
  position: absolute;
  top: 0px;
  left: 105%;
}
</style>
